import { ad2Colors, textColors } from "@/app/theme/palette";

/**
 * Every text color in the palette, as Studio dropdown options. Use this for a
 * component's color variable so its choices cannot drift from the design
 * tokens `defineDesignTokens` registers for `cfTextColor`.
 *
 * `light` and `contrastText` are both listed even though they are the same
 * white — each is the name a different set of pickers has always used, and the
 * stored value is identical either way.
 */
export const textColorOptions: {
  value: (typeof textColors)[keyof typeof textColors] | typeof ad2Colors.primaryBlue;
  displayName: string;
}[] = [
  { value: textColors.primary, displayName: "Primary" },
  { value: textColors.secondary, displayName: "Secondary" },
  { value: textColors.tertiary, displayName: "Tertiary" },
  { value: textColors.brand, displayName: "Brand" },
  { value: textColors.disabled, displayName: "Disabled" },
  { value: textColors.accent1, displayName: "Accent 1" },
  { value: textColors.accent2, displayName: "Accent 2" },
  { value: textColors.accent3, displayName: "Accent 3" },
  { value: textColors.light, displayName: "Light" },
  { value: textColors.contrastText, displayName: "Contrast Text" },
  // The /smile header blue (#0046F8), by name, for text and icons - matches the
  // "smileBlue" design token studio-config.ts registers for the Design tab.
  { value: ad2Colors.primaryBlue, displayName: "Smile Blue" },
];
